// Action Types
export const API_CALL_BEGAN = "apiCallBegin";
export const API_CALL_SUCCESS = "apiCallSucess";
export const API_CALL_FAILED = "apiCallFailed";

//Action Creators

export const apiCallBegan = (payload) => {
    //log.log('api Call Began',payload);
    return{
        type:API_CALL_BEGAN,
        payload:payload
    }
};
export const apiCallSuccess = payload => ({type:API_CALL_SUCCESS,payload});
export const apiCallFailed = payload => ({type:API_CALL_FAILED,payload});